import {    CANDIDATE_REQUESTED,
    CANDIDATE_RECEIVED,
    CANDIDATE_ERROR,

    } from "../actions/bpmnCandidate";
import RequestState from "../storage/RequestState";
import RequestResult from "../storage/RequestResult";
import {EMPTY_REQUEST_RESULT_INIT_STATE} from "../utils/JsObjectHelper";

/**
*
* @param {RequestResult} state
* @param {BaseAction|ReceiveEntryTypesAction|ReceiveErrorAction} action
* @return {RequestResult}
*/
export const candidate = (state = EMPTY_REQUEST_RESULT_INIT_STATE, action)  => {

switch (action.type) {
   case CANDIDATE_REQUESTED:
       return new RequestResult(RequestState.getInstanceLoading(), state.data);
   case CANDIDATE_RECEIVED:
       return new RequestResult(RequestState.getInstanceDone(), action.candidate, action.receivedAt);
   case CANDIDATE_ERROR:
       return new RequestResult(
           RequestState.getInstanceError(
               action.errorResponseStatusCode,
               action.errorResponseMessage ? action.errorResponseMessage : null
           ),
           state.getData()
       );
 
   default:
       return state
}
};
